export default __webpack_public_path__ + "static/media/voicegot-screenshot-06.902c5bd6.png";